// 文字列の数字にカンマをつける
export const convertStringToPrice = (price: string): string => {
  return String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
};
